import React, { useEffect, useState } from "react";
import { Landmark, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function NationalPaymentSettings() {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/admin/settings/national-payment").then((r) => setCfg(r.data)).catch(console.error); }, []);
  if (!cfg) return null;
  const upd = (k) => (e) => setCfg((c) => ({ ...c, [k]: e.target.value }));
  const save = async () => {
    try {
      const { data } = await api.put("/admin/settings/national-payment", { ...cfg, cancel_hours: Number(cfg.cancel_hours), reminder_hours: Number(cfg.reminder_hours) });
      setCfg(data); toast.success("Réglages virement enregistrés ✓");
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || "Erreur"); }
  };
  const inp = "bg-ink border border-zinc-700 px-3 py-2 text-white text-sm w-full focus:border-neon-green outline-none";
  return (
    <div data-testid="national-payment-settings" className="border border-zinc-800 bg-ink-surface mb-5">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left">
        <span className="font-anton uppercase text-white flex items-center gap-2"><Landmark className="h-4 w-4 text-neon-magenta" /> Paiement boutique nationale (virement instantané)</span>
        <span className="text-zinc-500 text-xs">{cfg.iban ? `IBAN …${cfg.iban.slice(-4)} · annulation ${cfg.cancel_hours}h` : "⚠️ IBAN à configurer"} {open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="text-xs text-zinc-400">Titulaire du compte<input data-testid="np-holder" value={cfg.holder} onChange={upd("holder")} className={inp} /></label>
          <label className="text-xs text-zinc-400">IBAN<input data-testid="np-iban" value={cfg.iban} onChange={upd("iban")} placeholder="FR76 …" className={`${inp} font-mono`} /></label>
          <label className="text-xs text-zinc-400">BIC (optionnel)<input data-testid="np-bic" value={cfg.bic} onChange={upd("bic")} className={`${inp} font-mono`} /></label>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-xs text-zinc-400">Annulation auto (h)<input data-testid="np-cancel" type="number" min="1" max="240" value={cfg.cancel_hours} onChange={upd("cancel_hours")} className={inp} /></label>
            <label className="text-xs text-zinc-400">Badge « à relancer » (h)<input data-testid="np-reminder" type="number" min="1" max="240" value={cfg.reminder_hours} onChange={upd("reminder_hours")} className={inp} /></label>
          </div>
          <button data-testid="np-save" onClick={save} className="sm:col-span-2 inline-flex items-center justify-center gap-2 bg-neon-green text-black font-anton uppercase px-4 py-2.5"><Save className="h-4 w-4" /> Enregistrer</button>
        </div>
      )}
    </div>
  );
}
